export const PageNotFoundSection = () => {
  return <>Page Not Found</>;
};
